

import { motion } from "motion/react";

export const FinalCTA = ({ onHiringStart }: { onHiringStart: () => void }) => {
  return (
    <section className="py-20 px-4 sm:px-8">
      <motion.div 
        whileInView={{ scale: [0.95, 1], opacity: [0, 1] }}
        className="max-w-7xl mx-auto rounded-[3rem] bg-brand-primary p-16 md:p-24 text-center text-white relative overflow-hidden shadow-2xl"
      >
        <div className="relative z-10 max-w-3xl mx-auto">
          <h2 className="text-5xl md:text-7xl font-display font-bold mb-8 tracking-tight leading-[0.95]">Start hiring with outcomes in mind</h2>
          <p className="text-xl md:text-2xl text-brand-secondary mb-12 font-medium italic">Let QuantumHire handle sourcing, screening, and shortlisting — so your team focuses on closing.</p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button 
              onClick={onHiringStart}
              className="px-10 py-5 bg-brand-accent text-brand-primary rounded-2xl text-xl font-bold hover:brightness-110 transition-all shadow-xl"
            >
              Get Started Now
            </button>
          </div>
        </div>
        
        <div className="absolute top-0 right-0 -mr-20 -mt-20 w-80 h-80 bg-brand-accent/20 rounded-full blur-3xl opacity-50" />
        <div className="absolute bottom-0 left-0 -ml-20 -mb-20 w-80 h-80 bg-brand-deep/20 rounded-full blur-3xl opacity-50" />
      </motion.div>
    </section>
  );
};
